function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { SyncPromise, logger, isThenable, getGlobalSingleton } from '@sentry/utils';
import { DEBUG_BUILD } from './debug-build.js';
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */

function getGlobalEventProcessors() {
  return getGlobalSingleton('globalEventProcessors', function () {
    return [];
  });
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */


function addGlobalEventProcessor(callback) {
  // eslint-disable-next-line deprecation/deprecation
  getGlobalEventProcessors().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */


function notifyEventProcessors(processors, event, hint) {
  var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return new SyncPromise(function (resolve, reject) {
    var processor = processors[index];

    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      var result = processor(_objectSpread({}, event), hint);
      DEBUG_BUILD && processor.id && result === null && logger.log("Event processor \"".concat(processor.id, "\" dropped event"));

      if (isThenable(result)) {
        void result.then(function (final) {
          return notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
        }).then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
      }
    }
  });
}

export { addGlobalEventProcessor, getGlobalEventProcessors, notifyEventProcessors };